import {Injectable} from '@angular/core';
import {RequestOptions, Headers} from '@angular/http';
import {HttpService} from '../http-service';
import {ConfigService} from '../config-service';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

/**
 * "Esqueci minha senha" por código de 6 dígitos (mesmo fluxo do WebGestor).
 * Endpoints públicos da API: /senha/esqueci e /senha/redefinir
 */
@Injectable()
export class SenhaProvider {

  // Manter em sincronia com RecuperacaoSenhaService::CARACTERES_ESPECIAIS (ecoenel-api)
  static readonly CARACTERES_ESPECIAIS = '!@#$%^&*?_~<>,';

  static readonly REQUISITOS = [
    {chave: 'length', descricao: 'Ao menos 8 caracteres', testa: (s: string) => s.length >= 8},
    {chave: 'lowercase', descricao: 'Uma letra minúscula', testa: (s: string) => /[a-z]/.test(s)},
    {chave: 'uppercase', descricao: 'Uma letra maiúscula', testa: (s: string) => /[A-Z]/.test(s)},
    {chave: 'number', descricao: 'Um número', testa: (s: string) => /[0-9]/.test(s)},
    {
      chave: 'special',
      descricao: 'Um caractere especial: ' + SenhaProvider.CARACTERES_ESPECIAIS,
      testa: (s: string) => s.split('').some(c => SenhaProvider.CARACTERES_ESPECIAIS.indexOf(c) !== -1)
    },
  ];

  constructor(private http: HttpService, private configService: ConfigService) {}

  solicitarCodigo(email: string): Promise<any> {
    return this.post('/senha/esqueci', {email});
  }

  redefinir(dados: { email: string, codigo: string, senha: string, senha_confirmacao: string }): Promise<any> {
    return this.post('/senha/redefinir', dados);
  }

  private post(url: string, body: any): Promise<any> {
    const options = new RequestOptions({
      headers: new Headers({'Content-Type': 'application/json', 'Accept': 'application/json'})
    });

    return this.http.post(url, this.configService.url, JSON.stringify(body), options)
      .map(res => res.json())
      .toPromise()
      .catch(err => {
        let mensagem = 'Não foi possível concluir a solicitação. Verifique sua conexão.';
        if (err && err.status === 429) {
          mensagem = 'Muitas tentativas. Aguarde um minuto e tente novamente.';
        } else {
          try {
            mensagem = err.json().error || mensagem;
          } catch (e) {}
        }
        return Promise.reject(mensagem);
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/senha/senha.provider.ts